import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import * as microsoftTeams from '@microsoft/teams-js';
import { isNil } from 'lodash';
import User from "../store/models/User";
import UserIntegration from "../store/models/UserIntegration";
import utils from 'src/mixins/utils';
export default {
  mixins: [utils],
  data: function data() {
    return {
      state: null
    };
  },
  methods: {
    loadIntegration: function loadIntegration(integrationCode) {
      var _this = this;

      var showLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (showLoading) {
        this.showLoading(this.$t('general.loading_integration'));
      }

      return this.$axios.get('/integrations/' + integrationCode).finally(function () {
        if (showLoading) {
          _this.hideLoading();
        }
      });
    },
    updateConfiguration: function updateConfiguration(integrationCode, config) {
      var _this2 = this;

      this.showLoading('Updating integration');
      return this.$axios.put('/integrations/' + integrationCode + '/configuration', config).finally(function () {
        _this2.hideLoading();
      });
    },
    onIntegrationOAuthGranted: function onIntegrationOAuthGranted(integrationCode, onComplete) {
      var _this3 = this;

      var integrations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return this.loadIntegration(integrationCode, false).then(function (response) {
        _this3.$root.$emit('integration-linked', integrationCode); // update me


        User.$me();
        var integrationLinked = integrationCode !== 'microsoftecosystem' && response.data.pivot;

        if (integrationCode === 'microsoftecosystem' && Array.isArray(response.data)) {
          integrationLinked = integrations.reduce(function (acc, integration) {
            var _response$data$find;

            return acc && !!((_response$data$find = response.data.find(function (i) {
              return i.integration_code === integration.integration_code;
            })) !== null && _response$data$find !== void 0 && _response$data$find.pivot);
          }, true);
        } // if we do not have a pivot we failed the link and thus we should display an error


        if (integrationLinked) {
          if (typeof onComplete === 'function') {
            onComplete(response.data);
          }
        } else {
          _this3.$q.notify({
            type: 'negative',
            message: _this3.$t('mixins.failed_to_link_integration')
          });
        }
      }).catch(function () {
        _this3.$q.notify({
          type: 'negative',
          message: _this3.$t('mixins.failed_to_get_integration')
        });
      }).finally(function () {
        _this3.hideLoading();
      });
    },
    link: function link(integrationCode) {
      var _this4 = this;

      var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var integrations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      //   this.$router.push('integrations/' + code)
      this.showLoading('Linking integration...'); // Generate state for the auth request

      this.state = this.generateRandomString(32);
      var requestAuthorizationUrl = "/integrations/".concat(integrationCode, "/auth-request?state=").concat(this.state);

      if (integrations.length) {
        requestAuthorizationUrl = requestAuthorizationUrl + '&' + this.objectToQueryString({
          integrations: integrations.map(function (i) {
            return i.integration_code;
          })
        });
      }

      this.$axios.get(requestAuthorizationUrl, {}).then(function (result) {
        if (_this4.isMicrosoftTeams) {
          // url encode result.data.redirectUri
          var redirectUri = btoa(result.data.redirectUri); // construct query object

          var query = '?redirect=' + redirectUri + '&sessionId=' + result.data.state + '&oauthRedirectMethod={oauthRedirectMethod}' + '&authId={authId}';

          _this4.hideLoading();

          microsoftTeams.authentication.authenticate({
            url: process.env.APP_URI + '/integration-auth/' + integrationCode + query,
            width: 1300,
            height: 535,
            isExternal: false
          }).then(function () {
            _this4.onIntegrationOAuthGranted(integrationCode, onComplete, integrations);
          }).catch(function (e) {
            _this4.$q.notify({
              message: e.message,
              type: 'negative'
            });
          }).finally(function () {
            _this4.hideLoading();
          });
        } else {
          var errorMessage = null;
          var param = '&state=' + JSON.stringify({
            sessionId: result.data.state
          });
          var popup = window.open(result.data.redirectUri + param, 'ModalPopUp', 'width=500,' + 'height=700');
          window.addEventListener('message', function (event) {
            if (event.data.error) {
              errorMessage = event.data.error;
            }
          }, false);
          var interval = setInterval(function () {
            if (popup && popup.closed) {
              clearInterval(interval);

              _this4.hideLoading();

              if (errorMessage) {
                _this4.$q.notify({
                  message: errorMessage,
                  type: 'negative'
                });

                localStorage.removeItem('integrationError');
              } else {
                _this4.onIntegrationOAuthGranted(integrationCode, onComplete, integrations);
              }
            } else if (isNil(popup)) {
              clearInterval(interval);

              _this4.hideLoading();
            }
          });
        }
      }).catch(function () {
        _this4.hideLoading();
      });
    },
    unlink: function unlink(integrationCode) {
      var _this5 = this;

      this.showLoading('Unlinking integration...');
      return this.$axios.post('/integrations/' + integrationCode + '/unlink-integration').then(function (result) {
        _this5.$root.$emit('integration-unlinked', integrationCode);

        UserIntegration.delete(function (userIntegration) {
          return userIntegration.integration_code === integrationCode && userIntegration.user_id === _this5.me.user_id;
        });
        User.$me(); // update me

        _this5.hideLoading();
      }).catch(function () {
        _this5.hideLoading();
      });
    },
    refreshToken: function refreshToken(integrationCode) {
      var _this6 = this;

      this.showLoading('Refreshing authorization...');
      this.$axios.get('/integrations/' + integrationCode + '/token-refresh').then(function (result) {
        _this6.hideLoading();

        _this6.$q.notify({
          message: _this6.$t('components.inviteUsersFromIntegrationDialog.authorization_refreshed'),
          type: 'positive'
        });
      }).catch(function () {
        _this6.hideLoading();
      });
    }
  }
};